import * as React from "react";
import type { SVGProps } from "react";
const SvgFileAttach03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M8.7 9.918v3.688a3.3 3.3 0 0 0 6.6 0V8.947a1.747 1.747 0 0 0-3.493 0v4.465M6.6 2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v14.4a2.4 2.4 0 0 1-2.4 2.4H6.6a2.4 2.4 0 0 1-2.4-2.4V4.8a2.4 2.4 0 0 1 2.4-2.4Z"
    />
  </svg>
);
export default SvgFileAttach03;
